<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import LaisField from 'dashboard/components-next/LaisField.vue';

const props = defineProps({
  companyOnly: { type: Boolean, default: false },
  readonly: { type: Boolean, default: false },
  row: { type: Object, required: true },
});

const emit = defineEmits(['update']);
const { t } = useI18n();
const personType = computed(() =>
  props.companyOnly ? 'PJ' : props.row.tipo_pessoa || 'PF'
);
const update = (field, event) => emit('update', field, event.target.value);
</script>

<template>
  <div class="mt-3 grid gap-3 md:grid-cols-2 xl:grid-cols-4">
    <LaisField
      v-if="!companyOnly"
      :label="t('REAL_ESTATE_COMMISSION_INSTALLMENT.FIELDS.PERSON_TYPE')"
    >
      <select
        :value="personType"
        :disabled="readonly"
        name="person-type"
        class="min-h-10 rounded-lais border border-lais-border bg-white px-3 text-sm disabled:cursor-not-allowed disabled:opacity-70"
        @change="update('tipo_pessoa', $event)"
      >
        <option value="PF">
          {{ t('REAL_ESTATE_COMMISSION_INSTALLMENT.PERSON_TYPES.PF') }}
        </option>
        <option value="PJ">
          {{ t('REAL_ESTATE_COMMISSION_INSTALLMENT.PERSON_TYPES.PJ') }}
        </option>
      </select>
    </LaisField>

    <LaisField
      v-if="personType === 'PF'"
      :label="t('REAL_ESTATE_COMMISSION_INSTALLMENT.FIELDS.FULL_NAME')"
      required
    >
      <input
        :value="row.name"
        :disabled="readonly"
        name="name"
        class="min-h-10 rounded-lais border border-lais-border bg-white px-3 text-sm disabled:cursor-not-allowed disabled:opacity-70"
        @input="update('name', $event)"
      />
    </LaisField>
    <LaisField
      v-if="personType === 'PF'"
      :label="t('REAL_ESTATE_COMMISSION_INSTALLMENT.FIELDS.CPF')"
      required
    >
      <input
        :value="row.cpf"
        :disabled="readonly"
        inputmode="numeric"
        name="cpf"
        class="min-h-10 rounded-lais border border-lais-border bg-white px-3 text-sm disabled:cursor-not-allowed disabled:opacity-70"
        @input="update('cpf', $event)"
      />
    </LaisField>
    <LaisField
      v-if="personType === 'PJ'"
      :label="t('REAL_ESTATE_COMMISSION_INSTALLMENT.FIELDS.BUSINESS_NAME')"
      required
    >
      <input
        :value="row.nome_empresarial"
        :disabled="readonly"
        name="business-name"
        class="min-h-10 rounded-lais border border-lais-border bg-white px-3 text-sm disabled:cursor-not-allowed disabled:opacity-70"
        @input="update('nome_empresarial', $event)"
      />
    </LaisField>
    <LaisField
      v-if="personType === 'PJ'"
      :label="t('REAL_ESTATE_COMMISSION_INSTALLMENT.FIELDS.CNPJ')"
      required
    >
      <input
        :value="row.cnpj"
        :disabled="readonly"
        inputmode="numeric"
        name="cnpj"
        class="min-h-10 rounded-lais border border-lais-border bg-white px-3 text-sm disabled:cursor-not-allowed disabled:opacity-70"
        @input="update('cnpj', $event)"
      />
    </LaisField>
    <LaisField
      :label="t('REAL_ESTATE_COMMISSION_INSTALLMENT.FIELDS.CRECI')"
      required
    >
      <input
        :value="row.creci"
        :disabled="readonly"
        name="creci"
        class="min-h-10 rounded-lais border border-lais-border bg-white px-3 text-sm disabled:cursor-not-allowed disabled:opacity-70"
        @input="update('creci', $event)"
      />
    </LaisField>
  </div>
</template>
